import isFunction from './isFunction';
export default function isIterable(subject) {
    return isFunction(subject[Symbol.iterator]);
}
